const competences_categories = {
  frontend: {
    title: "Développement Frontend",
    icon: "🎨",
    description: "Création d'interfaces utilisateur modernes et responsives",
    skills: [
      {
        name: "HTML5 & CSS3",
        description: "Sémantique moderne, Flexbox, Grid",
      },
      {
        name: "JavaScript ES6+",
        description: "Programmation moderne, Async/Await, modules",
      },
      {
        name: "TypeScript",
        description: "Typage statique, programmation orientée objet",
      },
      {
        name: "React",
        description:
          "Hooks personnalisés, Context API, optimisation des performances",
      },
      { name: "Vue.js", description: "Vue Router, gestion d’état avec Vuex" },
      { name: "Angular", description: "Composants, services, RxJS" },
      {
        name: "TailwindCSS",
        description: "Utilitaires CSS, personnalisation avancée",
      },
      { name: "Three.js", description: "WebGL, graphismes 3D, animations" },
    ],
  },
  backend: {
    title: "Développement Backend",
    icon: "⚙️",
    description: "APIs robustes et architecture serveur",
    skills: [
      { name: "Node.js", description: "Express.js, middlewares" },
      {
        name: "NestJS",
        description: "Architecture modulaire, injection de dépendances",
      },
      {
        name: "PHP",
        description: "Programmation orientée objet, namespaces, Composer",
      },
      {
        name: "Laravel",
        description: "Eloquent ORM, Artisan, Blade",
      },
      { name: "Symfony", description: "Bundles, Doctrine, Twig" },
    ],
  },
  database: {
    title: "Bases de Données",
    icon: "🗄️",
    description: "Conception et optimisation de bases de données",
    skills: [
      {
        name: "MySQL",
        description: "Requêtes complexes, optimisation, indexation",
      },
      {
        name: "PostgreSQL",
        description: "Fonctions avancées, gestion du JSON, extensions",
      },
    ],
  },
  cloud: {
    title: "Cloud & DevOps",
    icon: "☁️",
    description: "Déploiement et infrastructure cloud",
    skills: [
      {
        name: "Google Cloud Platform",
        description: "Compute Engine, Cloud Storage, App Engine, Pub/Sub",
      },
      {
        name: "Firebase",
        description: "Authentification, Firestore, hébergement",
      },
      { name: "Docker", description: "Conteneurisation, Docker Compose" },
      {
        name: "Git & GitHub",
        description: "Gestion de versions, CI/CD, collaboration",
      },
    ],
  },
  tools: {
    title: "Outils & Méthodologies",
    icon: "🛠️",
    description: "Environnement de développement et bonnes pratiques",
    skills: [
      {
        name: "VS Code",
        description: "Extensions, débogage, intégration Git",
      },
      { name: "Postman", description: "Tests d’API, documentation" },
      { name: "Webpack", description: "Regroupement de modules, optimisation" },
      { name: "Jest", description: "Tests unitaires, mocking" },
      {
        name: "Agile/Scrum",
        description: "Sprints, user stories, rétrospectives",
      },
      {
        name: "Cypress",
        description: "Tests end-to-end, tests d’intégration",
      },
    ],
  },
};

export { competences_categories };

export default competences_categories;
